import React from "react";
import { Card, Spin } from "antd";
import { LoadingOutlined } from "@ant-design/icons";
import CountUp from "react-countup";
import { useNavigate } from "react-router-dom";

interface TurnoverProps {
  data: {
    turnover: number;
  } | null;
  loading: boolean;
}

export default function Turnover({ data, loading }: TurnoverProps) {
  const navigate = useNavigate();
  if (loading) {
    return (
      <Card bordered={false} style={{ width: 300 }}>
        <Spin indicator={<LoadingOutlined spin />} />
      </Card>
    );
  }

  if (!data) {
    return (
      <Card bordered={false} style={{ width: 300 }}>
        <div>No data available</div>
      </Card>
    );
  }

  return (
    <Card bordered={false} style={{ width: 300 }} onClick={() => navigate("/turnover/logs")} hoverable >
      <h3>Общий оборот</h3>
      <CountUp
        start={0}
        end={data.turnover}
        duration={2.5}
        decimals={2}
        prefix="$"
        separator=" "
        style={{ fontSize: 30 }}
      />
    </Card>
  );
}
